import * as React from 'react';
import { connect } from 'react-redux';
import TabsModule from '../../Layout/TabsModule/TabsModule';
import POI from './POI';
import AOI from './AOI';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import * as HistoryModule from 'Modules/HistoryModule';
import { withTranslation  } from 'react-i18next';

export type State = {
    //
};
export type ConnectedProps = {
    viewManagementStore: ViewManagementModule.Types.ViewManagementStore;
    t?: (key: string) => string;
};
export type DispatchedProps = {
    changeZonesCurrentView: Function;
};
export type Props = {};

class POIManagement extends React.Component<Props & ConnectedProps & DispatchedProps, State> {
    constructor(props: Props & ConnectedProps & DispatchedProps) {
        super(props);
    }
    public render() {
        return (
            <div className="poi">
                <TabsModule onChildrenClick={e => this.props.changeZonesCurrentView(e)}>
                    <POI title={this.props.t('POI')} zone={HistoryModule.EnumTypes.ZonesViewType.POI} />
                    <AOI title={this.props.t('zones')} zone={HistoryModule.EnumTypes.ZonesViewType.AOI} />
                </TabsModule>
            </div>
        );
    }
}

function mapStateToProps(state: any): ConnectedProps {
    return {
        viewManagementStore: state.viewManagementStore
    };
}
function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        changeZonesCurrentView: (e: HistoryModule.EnumTypes.ZonesViewType) => dispatch(ViewManagementModule.Actions.SetActiveZoneView(e))
    };
}
export default withTranslation('forms')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(POIManagement) as React.ComponentType<any>
) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Map/POIManagement/PoiManagement.tsx